import { Doubts } from '@taxdown/piccolo-web';
import { useTranslation } from 'Hooks/useTranslation';
import { openLinkInNewTab } from 'Utils/links';
import { HelpInfoProps } from './types';

const HelpInfo = ({ info }: HelpInfoProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Doubts
      size="M"
      headerLabel={t('helpButton.title')}
      listDoubts={info.map(doubt => ({
        label: doubt.title || '',
        action: () => openLinkInNewTab(doubt.url || ''),
      }))}
    />
  );
};

export default HelpInfo;
